import service from "@irati/utils/tracking/index";
var RewardTracking = /** @class */ (function () {
    function RewardTracking() {
        this.rewardsTabHome = function () {
            service.trackRewardEvent("recognition_view_reward_homepage");
        };
        this.rewardsTabViewAllRewards = function () {
            service.trackRewardEvent("recognition_reward_viewall");
        };
        this.rewardsTabViewRewardDetails = function (reward) {
            service.trackRewardEvent("recognition_view_reward_detail", {
                recognition_reward_name: reward.header
            });
        };
        this.rewardsTabAddRewardStart = function (reward) {
            service.trackRewardEvent("recognition_start_create_reward", {
                recognition_reward_attached: reward.header
            });
        };
        this.rewardsTabAddRewardAddRecipient = function (recipients) {
            service.trackRewardEvent("recognition_add_recipient", {
                recognition_add_recipients: recipients.length
            });
        };
        this.rewardsTabAddRewardAddMessage = function () {
            service.trackRewardEvent("recognition_add_message");
        };
        this.rewardsTabAddRewardAddCompanyValues = function (basket) {
            service.trackRewardEvent("recognition_add_company_values", {
                recognition_add_companyValues: basket.companyValues.length
            });
        };
        this.rewardsTabAddRewardSuccess = function (recipientsCount, rewardTotal, rewardHeader) {
            service.trackRewardEvent("recognition_reward_send", {
                recognition_audience: recipientsCount,
                recognition_reward_attached: rewardHeader,
                recognition_reward_total: rewardTotal
            });
        };
        this.rewardsTabViewCustomRewardDetails = function () {
            service.trackRewardEvent("recognition_customreward_view");
        };
        this.rewardsTabAddCustomRewardStart = function () {
            service.trackRewardEvent("recognition_customreward_add");
        };
        this.rewardsTabAddCustomRewardSuccess = function (basket) {
            service.trackRewardEvent("recognition_customereward_send", {
                recognition_add_customReward: basket.custom
            });
        };
        this.recognitionTabFeedItemAddRewardStart = function (type) {
            service.trackRewardEvent("recognition_start_addreward", {
                recognition_feedItem_type: type
            });
        };
        this.recognitionTabFeedItemAddRewardSuccess = function (basket, reward, type) {
            service.trackRewardEvent("recognition_create_reward", {
                recognition_reward_attached: reward.header,
                recognition_reward_total: basket.costTotal,
                recognition_feedItem_type: type
            });
        };
        this.rewardsTabStartSendCredit = function () {
            service.trackRewardEvent("recognition_reward_start_send_credit");
        };
        this.rewardsTabAddCredit = function () {
            service.trackRewardEvent("recognition_reward_add_credit");
        };
        this.rewardsTabAddRecipient = function () {
            service.trackRewardEvent("recognition_reward_add_recipient");
        };
        this.rewardsTabCreditSend = function () {
            service.trackRewardEvent("recognition_reward_credit_send");
        };
    }
    return RewardTracking;
}());
var tracking = new RewardTracking();
export default tracking;
